// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.force-update-container {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  height: 100%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  position: relative;
  overflow: hidden;
  padding: 0;
}

.force-update-container::before {
  content: "";
  position: absolute;
  width: 500px;
  height: 500px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  top: -250px;
  right: -250px;
  animation: float 6s ease-in-out infinite;
}

.force-update-container::after {
  content: "";
  position: absolute;
  width: 400px;
  height: 400px;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 50%;
  bottom: -200px;
  left: -200px;
  animation: float 8s ease-in-out infinite reverse;
}

.update-card {
  text-align: center;
  width: 100%;
  max-width: 100%;
  background: #ffffff;
  padding: 48px 24px;
  border-radius: 24px 24px 0 0;
  box-shadow: 0 -10px 40px rgba(0, 0, 0, 0.3);
  position: relative;
  z-index: 1;
  animation: slideUp 0.6s ease-out;
}

.update-card .update-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 24px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 24px rgba(102, 126, 234, 0.4);
}

.update-card .update-icon ion-icon {
  font-size: 40px;
  color: #ffffff;
}

.update-title {
  font-size: 1.75rem;
  font-weight: 700;
  color: #1a1a2e;
  margin-bottom: 12px;
  letter-spacing: -0.5px;
}

.update-message {
  font-size: 1rem;
  font-weight: 400;
  color: #6c757d;
  margin-bottom: 32px;
  line-height: 1.6;
  max-width: 300px;
  margin-left: auto;
  margin-right: auto;
}

.update-button {
  --background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  --background-hover: linear-gradient(135deg, #7c93ee 0%, #8b5bb0 100%);
  --box-shadow: 0 8px 24px rgba(102, 126, 234, 0.4);
  font-weight: 600;
  font-size: 1.05rem;
  padding: 0 32px;
  border-radius: 12px;
  height: 52px;
  width: 100%;
  max-width: 280px;
  margin: 0 auto;
  display: block;
  text-transform: none;
  letter-spacing: 0.3px;
  transition: all 0.3s ease;
}

.update-button:hover {
  transform: translateY(-2px);
  --box-shadow: 0 12px 32px rgba(102, 126, 234, 0.5);
}

.update-button:active {
  transform: translateY(0);
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes float {
  0%, 100% {
    transform: translateY(0) rotate(0deg);
  }

  50% {
    transform: translateY(-20px) rotate(5deg);
  }
}

@media (max-width: 480px) {
  .update-card {
    padding: 40px 20px 32px;
    border-radius: 20px 20px 0 0;
  }

  .update-title {
    font-size: 1.5rem;
  }

  .update-message {
    font-size: 0.95rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/layouts/main/pages/force-update/force-update.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,qBAAA;EACA,YAAA;EACA,6DAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;AACF;;AAEE;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,oCAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,wCAAA;AAAJ;;AAGE;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,qCAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,gDAAA;AADJ;;AAKA;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,4BAAA;EACA,2CAAA;EACA,kBAAA;EACA,UAAA;EACA,gCAAA;AAFF;;AAKE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,6DAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,+CAAA;AAHJ;;AAKI;EACE,eAAA;EACA,cAAA;AAHN;;AAQA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;AALF;;AAQA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AALF;;AAQA;EACE,+DAAA;EACA,qEAAA;EACA,iDAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;EACA,oBAAA;EACA,qBAAA;EACA,yBAAA;AALF;;AAOE;EACE,2BAAA;EACA,kDAAA;AALJ;;AAQE;EACE,wBAAA;AANJ;;AAWA;EACE;IACE,UAAA;IACA,2BAAA;EARF;;EAUA;IACE,UAAA;IACA,wBAAA;EARF;AACF;;AAWA;EACE;IAEE,qCAAA;EAVF;;EAYA;IACE,yCAAA;EAVF;AACF;;AAcA;EACE;IACE,uBAAA;IACA,4BAAA;EAZF;;EAeA;IACE,iBAAA;EAbF;;EAgBA;IACE,kBAAA;EAdF;AACF","sourcesContent":[".force-update-container {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: flex-end;\r\n  height: 100%;\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  position: relative;\r\n  overflow: hidden;\r\n  padding: 0;\r\n\r\n  // Animated background elements\r\n  &::before {\r\n    content: \"\";\r\n    position: absolute;\r\n    width: 500px;\r\n    height: 500px;\r\n    background: rgba(255, 255, 255, 0.1);\r\n    border-radius: 50%;\r\n    top: -250px;\r\n    right: -250px;\r\n    animation: float 6s ease-in-out infinite;\r\n  }\r\n\r\n  &::after {\r\n    content: \"\";\r\n    position: absolute;\r\n    width: 400px;\r\n    height: 400px;\r\n    background: rgba(255, 255, 255, 0.08);\r\n    border-radius: 50%;\r\n    bottom: -200px;\r\n    left: -200px;\r\n    animation: float 8s ease-in-out infinite reverse;\r\n  }\r\n}\r\n\r\n.update-card {\r\n  text-align: center;\r\n  width: 100%;\r\n  max-width: 100%;\r\n  background: #ffffff;\r\n  padding: 48px 24px;\r\n  border-radius: 24px 24px 0 0;\r\n  box-shadow: 0 -10px 40px rgba(0, 0, 0, 0.3);\r\n  position: relative;\r\n  z-index: 1;\r\n  animation: slideUp 0.6s ease-out;\r\n\r\n  // Icon container (add this to your HTML)\r\n  .update-icon {\r\n    width: 80px;\r\n    height: 80px;\r\n    margin: 0 auto 24px;\r\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n    border-radius: 50%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    box-shadow: 0 8px 24px rgba(102, 126, 234, 0.4);\r\n\r\n    ion-icon {\r\n      font-size: 40px;\r\n      color: #ffffff;\r\n    }\r\n  }\r\n}\r\n\r\n.update-title {\r\n  font-size: 1.75rem;\r\n  font-weight: 700;\r\n  color: #1a1a2e;\r\n  margin-bottom: 12px;\r\n  letter-spacing: -0.5px;\r\n}\r\n\r\n.update-message {\r\n  font-size: 1rem;\r\n  font-weight: 400;\r\n  color: #6c757d;\r\n  margin-bottom: 32px;\r\n  line-height: 1.6;\r\n  max-width: 300px;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n}\r\n\r\n.update-button {\r\n  --background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  --background-hover: linear-gradient(135deg, #7c93ee 0%, #8b5bb0 100%);\r\n  --box-shadow: 0 8px 24px rgba(102, 126, 234, 0.4);\r\n  font-weight: 600;\r\n  font-size: 1.05rem;\r\n  padding: 0 32px;\r\n  border-radius: 12px;\r\n  height: 52px;\r\n  width: 100%;\r\n  max-width: 280px;\r\n  margin: 0 auto;\r\n  display: block;\r\n  text-transform: none;\r\n  letter-spacing: 0.3px;\r\n  transition: all 0.3s ease;\r\n\r\n  &:hover {\r\n    transform: translateY(-2px);\r\n    --box-shadow: 0 12px 32px rgba(102, 126, 234, 0.5);\r\n  }\r\n\r\n  &:active {\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n// Animations\r\n@keyframes slideUp {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(30px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n@keyframes float {\r\n  0%,\r\n  100% {\r\n    transform: translateY(0) rotate(0deg);\r\n  }\r\n  50% {\r\n    transform: translateY(-20px) rotate(5deg);\r\n  }\r\n}\r\n\r\n// Responsive adjustments\r\n@media (max-width: 480px) {\r\n  .update-card {\r\n    padding: 40px 20px 32px;\r\n    border-radius: 20px 20px 0 0;\r\n  }\r\n\r\n  .update-title {\r\n    font-size: 1.5rem;\r\n  }\r\n\r\n  .update-message {\r\n    font-size: 0.95rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
